import { render } from "./FileBox.vue?vue&type=template&id=bfa97f3c&scoped=true"
import script from "./FileBox.vue?vue&type=script&lang=js"
export * from "./FileBox.vue?vue&type=script&lang=js"

import "./FileBox.vue?vue&type=style&index=0&id=bfa97f3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa97f3c"]])

export default __exports__